module.exports = __webpack_public_path__ + "img/icon-clicked-offer.06c3fbd7.svg";